import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";

export default function AdminLogin() {
  const { user, login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (user && user.role) navigate("/admin");
  }, [user, navigate]);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    const res = await login(email, password);
    setLoading(false);
    if (res.ok) {
      toast.success("Welcome back!");
      navigate("/admin");
    } else {
      toast.error(res.error || "Login failed");
    }
  };

  return (
    <div className="min-h-screen grid lg:grid-cols-2 bg-[#FDFBF7] grain">
      <div className="hidden lg:block relative overflow-hidden">
        <img
          src="https://images.unsplash.com/photo-1595871151608-bc7abd1caca3?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzR8MHwxfHNlYXJjaHwxfHxsdXh1cnklMjBzcGElMjBzYWxvbiUyMGludGVyaW9yfGVufDB8fHx8MTc4NzI1MjU4MHww&ixlib=rb-4.1.0&q=85"
          alt="Salon"
          className="absolute inset-0 h-full w-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-[#2A1B1D]/80 to-[#2A1B1D]/20" />
        <div className="absolute bottom-12 left-12 text-[#FDFBF7]">
          <p className="font-display text-5xl">Munmun</p>
          <p className="text-sm tracking-[0.28em] uppercase text-[#D4AF37] mt-2">Owner Dashboard</p>
        </div>
      </div>

      <div className="flex items-center justify-center p-8">
        <motion.form
          onSubmit={submit}
          initial={{ opacity: 0, y: 24 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className="w-full max-w-sm"
          data-testid="admin-login-form"
        >
          <p className="text-[11px] tracking-[0.28em] uppercase text-[#8E3B46] font-semibold">Restricted</p>
          <h1 className="font-display text-4xl text-[#2A1B1D] mt-2">Owner Login</h1>
          <p className="text-sm text-[#5C4A4D] mt-2">Manage services, prices and bookings.</p>

          <div className="mt-8 space-y-4">
            <div>
              <label className="text-xs font-medium text-[#5C4A4D] mb-1.5 block">Email</label>
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                data-testid="admin-email"
                className="w-full rounded-xl border border-[#2A1B1D]/12 bg-white px-4 py-3 text-sm outline-none focus:border-[#D4AF37]"
                placeholder="admin@munmun.com"
              />
            </div>
            <div>
              <label className="text-xs font-medium text-[#5C4A4D] mb-1.5 block">Password</label>
              <input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                data-testid="admin-password"
                className="w-full rounded-xl border border-[#2A1B1D]/12 bg-white px-4 py-3 text-sm outline-none focus:border-[#D4AF37]"
                placeholder="••••••••"
              />
            </div>
          </div>

          <button
            type="submit"
            disabled={loading}
            data-testid="admin-login-submit"
            className="mt-7 w-full rounded-full bg-[#8E3B46] py-3.5 text-sm font-medium text-[#FDFBF7] hover:bg-[#722F38] transition-colors disabled:opacity-60"
          >
            {loading ? "Signing in..." : "Sign In"}
          </button>
          <a href="/" className="mt-5 block text-center text-xs text-[#5C4A4D] hover:text-[#8E3B46] transition-colors">← Back to website</a>
        </motion.form>
      </div>
    </div>
  );
}
